import * as React from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import { createContract, updateContract } from "../../http/contractApi";
import InputAdornment from "@mui/material/InputAdornment";
import SingersAdder from "../SingersAdder";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  height: 800,
  overflow: "auto",
};

const contractExample = {
  name: "Новый договор",
  singers: [],
  description: 0,
  vat: null,
};

export default function ContractSettings({ contract }) {
  const [state, setState] = React.useState(
    contract ? contract : contractExample
  );
  const [error, setError] = React.useState(false);
  const [vat, setVat] = React.useState(
    contract ? (contract.vat ? contract.vat : false) : false
  );

  const onHandleSubmit = async () => {
    const response = contract
      ? await updateContract(state.id, { contract: state })
      : await createContract({ contract: state });
    console.log(response);
    window.location.reload();
  };

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
    console.log(state);
  };

  const handleCheckboxChange = (event) => {
    setVat(event.target.checked);
  };

  const handleChangeSinger = (event) => {
    let stat = state;
    let item = stat.singers.find((x) => x.singer === event.target.name);
    item.profitPercentage = event.target.value;
    setState({
      ...state,
      singers: stat.singers,
    });
  };

  return (
    <Box sx={style}>
      <FormControl sx={{ m: 1, width: 300 }}>
        <TextField
          label="Название договора"
          variant="outlined"
          color="secondary"
          name="name"
          value={state.name}
          onChange={handleChange}
        />
      </FormControl>

      <SingersAdder state={state} setState={setState} />

      <FormControl sx={{ m: 1, width: 300 }}>
        <TextField
          color="secondary"
          id="outlined-multiline-static"
          label="Description"
          multiline
          rows={4}
          name="description"
          value={state.description}
          onChange={handleChange}
        />
      </FormControl>

      {state.singers &&
        state.singers.map(({ singer, profitPercentage }) => {
          return (
            <div key={singer}>
              <h3>{singer}</h3>
              <FormControl sx={{ m: 1, width: 300 }}>
                <TextField
                  color="secondary"
                  label="Процент исполнителя(лей)"
                  id="outlined-start-adornment"
                  name={singer}
                  type="number"
                  value={profitPercentage}
                  onChange={handleChangeSinger}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>
          );
        })}

      <FormControl
        error={error}
        component="fieldset"
        variant="standard"
        sx={{ m: 1, width: 300 }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={vat}
                onChange={handleCheckboxChange}
                name="vat"
              />
            }
            label="VAT"
          />
        </FormGroup>
      </FormControl>

      {vat && (
        <FormControl sx={{ m: 1, width: 300 }}>
          <TextField
            color="secondary"
            label="VAT"
            id="outlined-start-adornment"
            name="vat"
            type="number"
            value={state.vat}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </FormControl>
      )}

      <Button
        disabled={state.singers.length < 1}
        variant="contained"
        color="secondary"
        onClick={onHandleSubmit}
      >
        {contract ? "Изменить договор" : "Создать договор"}
      </Button>
    </Box>
  );
}
